import type { Database } from 'node-sqlite3-wasm';
import sqliteWasm from 'node-sqlite3-wasm';

export const SqliteDatabaseConstructor = (sqliteWasm as unknown as {
  Database: new (filename?: string, options?: { fileMustExist?: boolean; readOnly?: boolean }) => Database;
}).Database;

export type SqliteMigrateState = {
  migrateDoneForPath: string | null;
};

export function createSqliteMigrateState(): SqliteMigrateState {
  return { migrateDoneForPath: null };
}
